'use strict';

exports.__esModule = true;

var _Sandbox = require('./Sandbox');

var _Sandbox2 = _interopRequireDefault(_Sandbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a new instance of Sandbox.
 */
var createSandbox = function createSandbox() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(_Sandbox2.default, [null].concat(args)))();
};

exports.default = createSandbox;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/createSandbox.js
// module id = ZWqP
// module chunks = 0